import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.analytics !== 'undefined' && window.analytics?.page) {
      window.analytics.page({
        path: location.pathname,
        title: document.title,
        search: location.search,
        url: window.location.href,
      });
    }
  }, [location]);
};
